import { all, call, put, takeLatest } from 'redux-saga/effects';
import { getAppUserError, getAppUserRequest, getAppUserSuccess, logoutRequest } from './index';
import { getAppUser, getCsrfToken } from '../api/authApi';
import { BASE_URL } from '@shared/constants/urlsConstants';
import { LS_CSRF_TOKEN_KEY } from '@shared/constants/storagesKeysConstants';
import {
    updateNotifyDestinationSuccess,
    updateNotifyDestinationFailure,
    updateNotifyDestinationRequest,
} from './index';
import { changeNotifyDestination } from '../api/authApi';

function* getAppUserSaga() {
    try {
        const { data: UserResponseData } = yield call(getAppUser);

        // In development mode, when frontend and backend are on different origins, CSRF cookie can not be accessed via JS.
        // In production mode everything works as usual
        if (process.env.NODE_ENV === 'development') {
            const { data: CsrfTokenResponseData } = yield call(getCsrfToken);
            localStorage.setItem(LS_CSRF_TOKEN_KEY, CsrfTokenResponseData['csrf_token']);
        }

        yield put(getAppUserSuccess(UserResponseData));
    } catch (error) {
        if (error.response && error.response.status === 401) {
            window.location.href = `${BASE_URL}login/?origin_url=${encodeURIComponent(window.location.href)}`; // redirect to sso service
        } else {
            yield put(getAppUserError(error));
        }
    }
}

function* logoutSaga() {
    if (process.env.NODE_ENV === 'development') {
        localStorage.removeItem(LS_CSRF_TOKEN_KEY);
    }

    yield (window.location.href = `${BASE_URL}logout/`); // will clear cookie and redirect to sso service
}

function* updateNotifyDestinationSaga(action) {
    try {
        const response = yield call(changeNotifyDestination, action.payload);
        yield put(updateNotifyDestinationSuccess(response.data.notify_destination));
    } catch (error) {
        yield put(updateNotifyDestinationFailure(error.response?.data));
    }
}

export default function* authSagaWatcher() {
    yield all([
        takeLatest(getAppUserRequest, getAppUserSaga),
        takeLatest(logoutRequest, logoutSaga),
        takeLatest(updateNotifyDestinationRequest.type, updateNotifyDestinationSaga),
    ]);
}
